import type { Id } from "@convex/_generated/dataModel";
import { createFileRoute } from "@tanstack/react-router";
import { EmployeeSkills } from "@/features/skills/employee-skills";

export const Route = createFileRoute("/_app/_main/team/$employeeId/skills")({
  component: () => <EmployeeSkills employeeId={Route.useParams().employeeId as Id<"employees">} />,
});
